<div class="d-flex align-items-center menu-item language">
  <div
    class="d-flex align-items-center"
    *ngIf="languageService.current$ | async as language"
    [matMenuTriggerFor]="languageMenu">
    <sh-main-nav-language-flag [code]="language"></sh-main-nav-language-flag>
    <mat-icon>expand_more</mat-icon>
  </div>

  <mat-menu
    class="header-menu"
    #languageMenu="matMenu">
    <button
      class="header-menu-item"
      mat-menu-item
      *ngFor="let language of languageService.languageKeys"
      (click)="chooseLanguage(language)">
      <sh-main-nav-language-flag [code]="language"></sh-main-nav-language-flag>
      {{ 'language.' + language | transloco }}
    </button>
  </mat-menu>
</div>
